import { getToken } from '@/generated/client/chat/chat';

const tokenCacheValidInMs = 20000; // 20 sec

type TokenCache = {
  token: string | undefined;
  validUntil: number;
};

let tokenCache: TokenCache = {
  token: undefined,
  validUntil: -1,
};

function calcValidity() {
  return Date.now() + tokenCacheValidInMs;
}

function getTokenFromCache() {
  if (!tokenCache.token) return undefined;
  if (tokenCache.validUntil < Date.now()) {
    tokenCache.token = undefined;
    return undefined;
  }
  return tokenCache.token;
}

function putTokenIntoCache(token: string) {
  tokenCache = {
    token,
    validUntil: calcValidity(),
  };
}

export async function getChatToken(userId: string, apiKey: string) {
  const cachedToken = getTokenFromCache();
  if (cachedToken) return cachedToken;

  const tokenResponse = await getToken();
  putTokenIntoCache(tokenResponse.data);

  if (window.registerDeviceToStream) {
    const messageToFlutter = {
      streamUser: userId,
      streamKey: apiKey,
      streamToken: tokenResponse.data,
    };
    const streamMessage = JSON.stringify(messageToFlutter);
    window.registerDeviceToStream.postMessage(streamMessage);
  }
  return tokenResponse.data;
}
